import { ClientInferResponseBody } from "@ts-rest/core";

import { api } from "#app/http/api";
import { contract } from "#app/http/api";

export type QuoteRequestLineBulkDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.findMany
>;

export const fetchQuoteRequestLinesBulk = async ({
  ids,
}: {
  ids: string[];
}): Promise<QuoteRequestLineBulkDto> => {
  if (ids.length === 0) {
    return [];
  }

  const response = await api.quoteRequestLines.findMany.mutation({
    body: {
      ids,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
